/**
 * Event start/end time validation (frontend).
 */

function parseTimeToMinutes(timeStr) {
  if (!timeStr || typeof timeStr !== 'string') return null;
  const match = timeStr.trim().match(/^(\d{1,2}):(\d{2})/);
  if (!match) return null;
  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  return hours * 60 + minutes;
}

export function isMultiDayEvent(date, endDate) {
  if (!date || !endDate) return false;
  return endDate > date;
}

export function validateEventTimeRange({ date, endDate, startTime, endTime }) {
  if (!startTime || !endTime) return null;

  const startMinutes = parseTimeToMinutes(startTime);
  const endMinutes = parseTimeToMinutes(endTime);
  if (startMinutes == null || endMinutes == null) return null;

  if (isMultiDayEvent(date, endDate)) {
    return null;
  }

  if (endMinutes <= startMinutes) {
    return 'End time must be after start time on the same day. If the event ends the next day, set an end date.';
  }

  return null;
}

export function getEndTimeMin({ date, endDate, startTime }) {
  if (!startTime || isMultiDayEvent(date, endDate)) return undefined;
  return startTime;
}
